<div class="d-flex flex-column vh-100 bg-white">

    <lib-toast></lib-toast>
    <lib-loader></lib-loader>

    @if(userService.IsLogin() && !isLiveScorePage && !isPublicRegisterPage) {
    <app-header [liveScoreMenu]="liveScoreMenu"></app-header>

    <!-- Main Layout -->
    <main class="d-flex flex-grow-1 overflow-hidden position-relative">

        <!-- MAIN SIDEBAR (off-canvas drawer on mobile) -->
        <app-sidebar [userMenus]="userMenus"></app-sidebar>
        @if (layout.isMobile() && layout.drawerOpen()) {
        <div class="drawer-backdrop" (click)="layout.closeDrawer()" aria-hidden="true"></div>
        }

        <!-- CONTENT (overflow owned by .app-content in app.scss — Bootstrap's
             .overflow-auto is !important and would defeat the mobile guard) -->
        <div class="app-content flex-grow-1 position-relative" [class.bg-white]="!isDashboardView && !isLiveScorePage"
            [class.bg-view]="isDashboardView" [class.p-3]="!isLiveScorePage && !isDashboardView"
            [class.content-with-bottom-nav]="layout.isMobile()">
            <div [class.container-fluid]="!isLiveScorePage && !isDashboardView">
                <router-outlet></router-outlet>
            </div>
        </div>

    </main>

    @if (layout.isMobile()) {
    <app-bottom-nav [userMenus]="userMenus"></app-bottom-nav>
    }
    } @else {
    <router-outlet></router-outlet>
    }

</div>

<!-- #region Templates -->
<ng-template #bulkMatchTransferTemplate>
    <!-- Ring Transfer Overview Card -->
    <div class="mb-3 p-3 border rounded d-flex justify-content-between align-items-center"
        style="background-color: #f8f9fa;">
        <div>
            <span class="extra-small fw-bold text-muted text-uppercase d-block mb-1"
                style="font-size: 0.7rem; letter-spacing: 0.5px;">Current Ring</span>
            <span class="fs-6 fw-bold text-dark d-flex align-items-center gap-1">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6c757d;">grid_view</mat-icon>
                Ring {{ currentRingNo }}
            </span>
        </div>
        <div class="text-end">
            <span class="extra-small fw-bold text-muted text-uppercase d-block mb-1"
                style="font-size: 0.7rem; letter-spacing: 0.5px;">Destination Ring</span>
            <span class="fs-6 fw-bold text-primary d-flex align-items-center gap-1 justify-content-end"
                *ngIf="targetRingNo">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #0d6efd;">swap_horiz</mat-icon>
                Ring {{ targetRingNo }}
            </span>
            <span class="fs-6 fw-bold text-muted d-flex align-items-center gap-1 justify-content-end"
                *ngIf="!targetRingNo">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6c757d;">swap_horiz</mat-icon>
                Select Ring...
            </span>
        </div>
    </div>
    <div class="mb-3">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="small fw-bold text-muted text-uppercase">Transfer Matches</span>
            <div class="d-flex align-items-center gap-3">
                <div class="extra-small text-muted fw-bold">{{ selectedMatchIds.length }} selected</div>
                <mat-checkbox [checked]="isAllSelected()" (change)="toggleSelectAll()" color="primary">
                    <span class="extra-small fw-bold">SELECT ALL</span>
                </mat-checkbox>
            </div>
        </div>
        <div class="overflow-auto border rounded" style="max-height: 250px; background: #fbfbfb;">
            <div *ngFor="let m of remainingMatches"
                class="d-flex align-items-center px-3 py-2 border-bottom hover-bg-light"
                (click)="toggleMatchSelection(m.match_id)" style="cursor: pointer;">
                <mat-checkbox [checked]="selectedMatchIds.includes(m.match_id)" (click)="$event.stopPropagation()"
                    (change)="toggleMatchSelection(m.match_id)" color="primary"></mat-checkbox>
                <div class="ms-3 flex-grow-1">
                    <div class="small fw-bold">#{{ m.match_id }} - {{ m.match_name }}</div>
                    <div class="extra-small text-muted text-uppercase">Round {{ m.round_no }} | Match {{ m.match_index
                        }} | Ring {{
                        m.ring_number || m.ring_no || currentRingNo }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="mb-2 px-1">
        <label class="form-label extra-small fw-bold text-muted text-uppercase d-block mb-1">Destination Ring</label>
        <lib-input-select [masterList]="ringList" [(selectedValue)]="targetRingNo" [showClearButton]="false"
            inputLabel="Select Target Ring">
        </lib-input-select>
    </div>
</ng-template>
<!-- #endregion -->